<template>
  <FreeBottomSheet :name="name">
    <template #default>
      <div class="relative pt-1">
        <div class="mx-1 rounded-[20px] bg-[rgb(144,215,242)]/60">
          <img class="rounded-[20px]" :src="cashbackPromoImage" alt="" />
        </div>
        <FreeCloseButton
          class="close-button absolute top-3 right-3"
          @click="$emit('onClose')"
        />
        <div class="mt-8 space-y-2 px-6 text-center">
          <h2 class="text-[24px] font-bold text-balance">
            {{ yourCashbackTitle }}
          </h2>
          <p class="text-text-neutral-secondary text-base">
            {{
              isPromoActive
                ? t('cashback-promo.active-description')
                : t('cashback-promo.description')
            }}
          </p>
        </div>
        <div class="px-3">
          <FreeButton
            class="green-main-button mt-7 w-full"
            @click="$emit('onShowDetails')"
          >
            {{
              isPromoActive
                ? t('cashback-promo.active-learn-more')
                : t('cashback-promo.learn-more')
            }}
          </FreeButton>
        </div>
      </div>
    </template>
  </FreeBottomSheet>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { useI18n } from 'vue-i18n';

  import cashbackPromoImage from '../assets/cashback-promo-image.webp';
  import {
    FreeBottomSheet,
    FreeButton,
    FreeCloseButton,
  } from '../../../shared/ui';
  import messages from '../locales.json';

  const props = defineProps<{
    name: string;
    isPromoActive: boolean;
  }>();

  defineEmits<{
    onShowDetails: [];
    onClose: [];
  }>();

  const { t } = useI18n({ messages });

  const yourCashbackTitle = computed(() => {
    if (props.isPromoActive) {
      return t('cashback-promo.active-title');
    }

    return t('cashback-promo.title');
  });
</script>

<style scoped>
  .close-button {
    --header-close-button-cross-color: rgb(
      var(--background-neutral-quaternary)
    );
  }
</style>
